import React, { useState } from "react";
import Swal from "sweetalert2";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { isValidPhoneNumber } from "react-phone-number-input";
// ✅ Import images
import phoneIcon from "../../Assets/img/mobile (1) 1.svg";
import emailIcon from "../../Assets/img/email (1) 1.svg";
import indiaFlag from "../../Assets/img/flag (1) 2.svg";
import uaeFlag from "../../Assets/img/united-arab-emirates (1) 1.svg";
import { contactsApi } from "../../API/Api";

const ReachOut = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, phone: value });
    setErrors({ ...errors, phone: "" });
  };

  const validate = () => {
    const newErrors = {};

    // First name
    if (!formData.firstName.trim())
      newErrors.firstName = "First name is required";

    // Last name
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    // Email
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }
    // Phone
    // Phone
if (!formData.phone) {
  newErrors.phone = "Phone number is required";
} else if (!isValidPhoneNumber(formData.phone)) {
  newErrors.phone = "Enter a valid phone number";
}


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      Swal.fire({
        title: "Validation Error",
        text: "Please fix the highlighted fields.",
        icon: "error",
        confirmButtonColor: "#d33",
      });
      return;
    }

    try {
      await contactsApi.createContact(formData);

      Swal.fire({
        title: "Success!",
        text: "Your message has been sent successfully.",
        icon: "success",
        confirmButtonColor: "#6f42c1",
      });

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });
      setErrors({});
    } catch (err) {
      console.error(err);
      Swal.fire({
        title: "Error",
        text: "Failed to send message. Try again later.",
        icon: "error",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <>
      <div className="container mt-5 mb-lg-5">
        <div className="row">
          {/* LEFT SECTION */}
          <div className="col-md-6 pe-md-5 mb-4">
            <h3 className="fw-bold">Reach Out — Let’s Work Together</h3>
            <p className="text-justify">
              We're here to help you find the right staffing solutions for your
              needs. Whether you're a company looking to hire top talent or a
              candidate seeking your next career opportunity.
            </p>

            <div className="divider-contect"></div>

            {/* Contact Row */}
            <div className="row align-items-center text-center">
              <div className="col position-relative">
                <img
                  src={phoneIcon}
                  alt="Phone Icon"
                  className="icon-contact mb-2"
                />
                <div>Give us a call</div>
                <div className="text-purple fw-bold fs-6">+91 9023148808</div>
                <div className="v-line-absolute d-none d-md-block"></div>
              </div>
              <div className="col text-center">
                <img
                  src={emailIcon}
                  alt="Email Icon"
                  className="icon-contact mb-2"
                />
                <div>Send the email</div>
                <div className="fw-bold fs-6">
                  <a
                    href="mailto:info@anaxistech.com"
                    className="text-purple text-decoration-none fs-6"
                  >
                    info@anaxistech.com
                  </a>
                </div>
              </div>
            </div>

            <div className="divider-contect"></div>

            {/* Address Row */}
            <div className="row align-items-center text-center">
              <div className="col position-relative">
                <img
                  src={indiaFlag}
                  alt="India Flag"
                  className="flag-contact mb-2 mt-lg-5 mt-sm-3"
                />
                <p className="small text-center text-lg-justify">
                  Anaxis House, Makarba Road,
                  <br />
                  Ahmedabad, 380058
                </p>

                <div className="v-line-absolute d-none d-md-block"></div>
              </div>
              <div className="col position-relative">
                <img
                  src={uaeFlag}
                  alt="UAE Flag"
                  className="flag-contact mb-2 mt-lg-5 mt-sm-3"
                />
                <p className="small text-center text-lg-justify">
                  776 DMCC Jewellery And Gemplex 3 <br /> Dubai, UAE 336899.
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT SECTION (FORM) */}
          <div className="col-md-6">
            <div className="form-section row m-0">
              <h5 className="text-center fw-bold mb-3">
                Feel free to reach out
              </h5>
              <p>
                Feel free to reach out to us with any questions, inquiries, or
                staffing requirements you may have. Our experienced
              </p>
              <form onSubmit={handleSubmit}>
                <div className="d-flex mb-3 gap-1">
                  <div className="col">
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      className={`form-control ${
                        errors.firstName ? "is-invalid" : ""
                      }`}
                      placeholder="First Name"
                    />
                    <div className="invalid-feedback">{errors.firstName}</div>
                  </div>
                  <div className="col">
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      className={`form-control ${
                        errors.lastName ? "is-invalid" : ""
                      }`}
                      placeholder="Last Name"
                    />
                    <div className="invalid-feedback">{errors.lastName}</div>
                  </div>
                </div>

                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`form-control ${
                      errors.email ? "is-invalid" : ""
                    }`}
                    placeholder="Email"
                  />
                  <div className="invalid-feedback">{errors.email}</div>
                </div>

               <div className="mb-3">
  <PhoneInput
    international
    defaultCountry="IN"
    value={formData.phone}
    onChange={handlePhoneChange}
    placeholder="Phone Number"
    className={`custom-phone-input ${
      errors.phone ? "is-invalid" : ""
    }`}
  />

  {errors.phone && (
    <div className="invalid-feedback d-block">
      {errors.phone}
    </div>
  )}
</div>


                <div className="mb-3">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className={`form-control`}
                    placeholder="Share Your Requirements"
                    rows="4"
                  ></textarea>
                </div>

                <div className="d-grid">
                  <button type="submit" className="btn-purple">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .btn-purple {
          display: block !important;
        }
      `}</style>
    </>
  );
};

export default ReachOut;
